import { render, staticRenderFns } from "./TablePendentes.vue?vue&type=template&id=0f72a1d2&"
import script from "./TablePendentes.vue?vue&type=script&lang=js&"
export * from "./TablePendentes.vue?vue&type=script&lang=js&"
import style0 from "./TablePendentes.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports